import { Flex, Box, Text, useMediaQuery, Link } from '@chakra-ui/react';
import ChakraMarkdown from '../../components/ChakraMarkdown';
import Layout from '../../components/Layout';
import Seo from '../../components/Seo';
import CustomButton from '../../components/CustomButton';

const contentOne = `You want to keep your audience engaged and returning regularly to your WordPress site for updates.

  One way of doing that is to regularly curate and share high quality, recent and relevant content on the topics your audience cares about.

  But finding, filtering and sharing quality takes time. Time you probably don't have. You could just pull in some RSS feeds - but then you have no control over what gets displayed.

  Full Curation, Complete Control: Anders Pink Plugin for WordPress

  Our curation plugin for WordPress makes it easier to find and share great content from anywhere on the web that your audience will love.

  - Set the rules for the content you want to curate: Choose specific sites, twitter influencers and RSS feeds. You control the sources.
  - Filter them by the keywords: pull through content on any topic, for example “digital banking trends” or “Facebook Marketing” - whatever fits with your audience and content themes. You have complete control over what's displayed - much more powerful than an RSS feed on its own.
  - Use the plugin to embed recent trending content alongside your blog posts, or on any page in your WordPress site.
  - Display recent content automatically, or hand-pick the articles you want to display.
`;

const contentTwo = `See how we use it to share [content curation tips as a sidebar on our blog here](https://anderspink.com/article/12-practical-ways-to-use-content-curation-to-support-learning-and-performance/)`;

const contentThree = `Get the WordPress plugin [here](https://api.github.com/repos/anderspink/ap_wordpress_plugin/zipball)`;

const contentFour = `For pricing information. A free trial may be available. We also offer some advanced add-ons that enable you to create briefings and saved boards using the API, which means your end-users can create briefings inside your platform for a fully integrated experience.`;

const Wordpress = ({ global }) => {
  const [isLargerThan1024] = useMediaQuery('(min-width: 1024px)');

  return (
    <Layout global={global}>
      <Seo seo={{}} />
      <Flex
        direction="column"
        margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}
        maxW={720}
      >
        <Box alignSelf="center">
          <Text
            fontSize="1.6rem"
            fontWeight="700"
            color="#006067"
            textAlign="center"
            my={10}
            maxW={520}
          >
            Content Curation WordPress PlugIn
          </Text>
        </Box>
        <ChakraMarkdown content={contentOne} onLinkClick={() => null} />
        <ChakraMarkdown content={contentTwo} onLinkClick={() => null} />
        <div
          style={{
            boxShadow: '0px 0px 12px rgba(0,0,0,0.5)',
            padding: '20px',
            backgroundColor: '#FFF',
            width: '500px',
            maxWidth: '100%',
            margin: '30px 0',
          }}
        >
          <img src="/wordpress1.png" style={{ maxWidth: '100%' }} />
        </div>

        <ChakraMarkdown content={contentThree} onLinkClick={() => null} />

        <Link
          href={'/contact'}
          style={{ textDecoration: 'none' }}
          target="_blank"
        >
          <CustomButton
            title="Contact us"
            backgroundColor="#cf0032"
            margin="10px 0"
          />
        </Link>

        <ChakraMarkdown content={contentFour} onLinkClick={() => null} />
      </Flex>
    </Layout>
  );
};

export default Wordpress;
